import React from 'react';

import { THTMLRender } from './interfaces';

const HTMLRender: React.FC<THTMLRender> = ({ children }) => (
    <div dangerouslySetInnerHTML={{ __html: children as string }}></div>
);

export default HTMLRender;